export enum CountryQuery {
	// TODO: TEMP translation bug
	// Restore when fixed: "?sort=name|asc&fields=id,name&rpp=1000&translate=true"
	"DataConfirmation" = "?sort=name|asc&rpp=1000&translate=true",
	"OasisBlockData" = "?sort=name|asc&rpp=1000&translate=true",
	// TODO: TEMP translation bug
	// Restore when fixed: "?sort=name|asc&fields=id,name,nationality,abrv&rpp=1000&translate=true"
	"DEFAULT" = "?sort=name|asc&rpp=1000&translate=true",
}
